import {ArgValidator} from './ArgValidator'
import {endsWith as _endsWith} from 'lodash';

/**
 * StringUtils are used for easier work with strings.
 * @class StringUtils
 */
export class StringUtils {

    /**
     * Returns boolean from string.
     * @method parseBoolean
     * @param s string to parse to boolean
     * @return boolean
     */
    static parseBoolean(s: string): boolean {
        switch (s.toUpperCase()) {
            case 'TRUE':
                return true;
            case '1':
                return true;
        }

        return false;
    }

    /**
     * Returns hex number of color from string. Add # if param s doesnt have on first character.
     * @method hexColor
     * @param s string to parse to hex color
     * @return string
     */
    static hexColor(s: string): string {
        ArgValidator.ensureStringIsNotNullOrEmpty(s, 's');

        if (s.substring(0, 1) === '#') {
            return s;
        } else {
            return '#' + s;
        }
    }

    /*
     /!**
     * Return fixed value of number.
     * @method fixValue
     * @param value number
     * @return string
     *!/
     static fixValue(value: number): string {
     return value.toFixed(2).toString();
     }
     */

    /**
     * Return true if string start with searchString
     * @method startsWith
     * @param str string
     * @param searchString string
     * @return boolean
     */
    static startsWith(str: string, searchString: string): boolean {
        return str.indexOf(searchString) === 0;
    }

    /**
     * Return true if string ends with searchString
     * @method startsWith
     * @param str string
     * @param searchString string
     * @return boolean
     */
    static endsWith(str: string, searchString: string): boolean {
        return _endsWith(str, searchString);
    }

    /**
     * Return true if string is null, undefined or empty.
     * @method isNullOrEmpty
     * @param str string
     * @return boolean
     */
    static isNullOrEmpty(str: string): boolean {
        return str === null || str === undefined || str === '';
    }

    static equals(str1: string, str2: string, ignoreCase: boolean): boolean {
        if (ignoreCase === undefined || ignoreCase === null) {
            ignoreCase = true;
        }

        if (ignoreCase) {
            str1 = this.isNullOrEmpty(str1) ? str1 : str1.toLocaleLowerCase();
            str2 = this.isNullOrEmpty(str2) ? str2 : str2.toLocaleLowerCase();

            return str1 === str2;
        }

        return str1 === str2;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/StringUtils.ts
 **/